import { render, staticRenderFns } from "./MyCabinetMenu.vue?vue&type=template&id=ef6adb8c&scoped=true&"
import script from "./MyCabinetMenu.vue?vue&type=script&lang=js&"
export * from "./MyCabinetMenu.vue?vue&type=script&lang=js&"
import style0 from "./MyCabinetMenu.vue?vue&type=style&index=0&id=ef6adb8c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6adb8c",
  null
  
)

export default component.exports